<ng-container *ngIf="isBrowser && configs?.swiperConfig as swiperConfig">
<div [classList]="configs.wrapperClasslist" [id]="configs.wrapperId">
  <swiper [config]="swiperConfig" #swiper>
    <ng-template swiperSlide *ngFor="let cardData of dataSource, let i = index">
      <ng-container [ngTemplateOutlet]="configs.template!" [ngTemplateOutletContext]="{data: cardData, index: i}"></ng-container>
    </ng-template>
  </swiper>
</div>
</ng-container>
